/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as LandingRouteImport } from './routes/landing'
import { Route as LoginRouteImport } from './routes/login'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as OauthConsentRouteImport } from './routes/oauth.consent'
import { Route as SettingsMailRouteImport } from './routes/settings.mail'
import { Route as SettingsMcpTokensRouteImport } from './routes/settings.mcp-tokens'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LandingRoute = LandingRouteImport.update({
  id: '/landing',
  path: '/landing',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const OauthConsentRoute = OauthConsentRouteImport.update({
  id: '/oauth/consent',
  path: '/oauth/consent',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsMailRoute = SettingsMailRouteImport.update({
  id: '/settings/mail',
  path: '/settings/mail',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsMcpTokensRoute = SettingsMcpTokensRouteImport.update({
  id: '/settings/mcp-tokens',
  path: '/settings/mcp-tokens',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/landing': typeof LandingRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/settings/mail': typeof SettingsMailRoute
  '/settings/mcp-tokens': typeof SettingsMcpTokensRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/landing': typeof LandingRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/settings/mail': typeof SettingsMailRoute
  '/settings/mcp-tokens': typeof SettingsMcpTokensRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/landing': typeof LandingRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/settings/mail': typeof SettingsMailRoute
  '/settings/mcp-tokens': typeof SettingsMcpTokensRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/landing'
    | '/login'
    | '/register'
    | '/oauth/consent'
    | '/settings/mail'
    | '/settings/mcp-tokens'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/landing'
    | '/login'
    | '/register'
    | '/oauth/consent'
    | '/settings/mail'
    | '/settings/mcp-tokens'
  id:
    | '__root__'
    | '/'
    | '/forgot-password'
    | '/landing'
    | '/login'
    | '/register'
    | '/oauth/consent'
    | '/settings/mail'
    | '/settings/mcp-tokens'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LandingRoute: typeof LandingRoute
  LoginRoute: typeof LoginRoute
  RegisterRoute: typeof RegisterRoute
  OauthConsentRoute: typeof OauthConsentRoute
  SettingsMailRoute: typeof SettingsMailRoute
  SettingsMcpTokensRoute: typeof SettingsMcpTokensRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/landing': {
      id: '/landing'
      path: '/landing'
      fullPath: '/landing'
      preLoaderRoute: typeof LandingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oauth/consent': {
      id: '/oauth/consent'
      path: '/oauth/consent'
      fullPath: '/oauth/consent'
      preLoaderRoute: typeof OauthConsentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/mail': {
      id: '/settings/mail'
      path: '/settings/mail'
      fullPath: '/settings/mail'
      preLoaderRoute: typeof SettingsMailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/mcp-tokens': {
      id: '/settings/mcp-tokens'
      path: '/settings/mcp-tokens'
      fullPath: '/settings/mcp-tokens'
      preLoaderRoute: typeof SettingsMcpTokensRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LandingRoute: LandingRoute,
  LoginRoute: LoginRoute,
  RegisterRoute: RegisterRoute,
  OauthConsentRoute: OauthConsentRoute,
  SettingsMailRoute: SettingsMailRoute,
  SettingsMcpTokensRoute: SettingsMcpTokensRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
